import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { faMobileAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import { AccelOneLogo } from '../../assets/images';
import { COLORS } from '../../constants/colors';
import { FOOTER } from '../../constants/props';
import useWindowSize from '../../hooks/useWindowSize';
import Interview from '../interview';
import Item from './item';

const useStyles = makeStyles({
  footer: {
    backgroundColor: COLORS.grayScale[1],
  },
  container: {
    maxWidth: '90rem',
    padding: '0 3.125rem',
    ['@media (max-width:442px)']: {
      padding:'2.5%',
    }
  },
  grid: {
    minHeight: '12.6875rem',
  },
  accelOne: {
    height: '3.3125rem',
  },
  interview: {
    marginTop: 10,
    ['@media (max-width:650px)']: {
      width:171,
    }
  },
});

const Footer = ({ withInterview }) => {
  const classes = useStyles();
  const size = useWindowSize();

  return (
    <footer className={classes.footer}>
      <Container className={classes.container}>
        <Grid
          className={classes.grid}
          container
          justify="space-between"
          alignItems="center"
        >
          <Grid>
            <Grid item>
              <img
                className={classes.accelOne}
                src={AccelOneLogo}
                alt="AccelOne logo"
              />
            </Grid>
            <Grid item className={classes.interview}>
            {withInterview && <Interview/>}
            </Grid>
          </Grid>

          <Grid item container xs={6} justify="space-around">
            <Item
              icon={<FontAwesomeIcon size={size.width>515?"3x":"2x"} icon={faMobileAlt} />}
              label="Contact Number"
              description="1 (800) 863 6814"
            />
            <Item
              icon={<FontAwesomeIcon size={size.width>515?"3x":"2x"} icon={faEnvelope} />}
              label="Email address"
              description="info@accelone.com"
            />
          </Grid>

        </Grid>
      </Container>
    </footer>
  );
};

Footer.defaultProps = {
  withInterview: true,
};

Footer.propTypes = {
  FOOTER,
};

export default Footer;
